import React from "react";
import { cropr, gettext } from "../../adapter";
import moment from "moment";
import { ReactComponent as DropIcon } from "./../../images/svg/drop.svg";
import { ReactComponent as AlertIcon } from "./../../images/svg/alert.svg";
import { ReactComponent as CircleIcon } from "./../../images/svg/circle.svg";
import { useLocation, useRouteMatch, Link } from "react-router-dom";

function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

const ListItem = ({ sensor }) => {
  const location = useLocation();
  const match = useRouteMatch();

  var statusColor = "icon is-small text-red is-inline has-left-spacing";
  if (sensor.status === "new") {
    statusColor = "icon is-small text-gray is-inline has-left-spacing";
  } else if (sensor.status === "on") {
    statusColor = "icon is-small text-green is-inline has-left-spacing";
  } else if (sensor.status === "onNoData" || sensor.status === "offData") {
    statusColor = "icon is-small text-yellow is-inline has-left-spacing";
  }

  var positionError = "";
  if (sensor.latitude === 0.0 && sensor.longitude === 0.0) {
    positionError = <AlertIcon className="icon text-red is-inline has-left-spacing" />;
  }

  // Format soil moisture values
  var soilMoisture = "-";
  var precision = cropr.l10n.unit_precipitation === "in" ? 1 : 0;

  if (
    sensor.period === "now" &&
    sensor.status !== "onNoData" &&
    (sensor.soilMoisture || sensor.soilMoisture === 0)
  ) {
    soilMoisture = (
      <strong>
        {cropr.l10n_utils.mm_to_l10n(round(sensor.soilMoisture, precision))}
        {" " + cropr.l10n.unit_precipitation_display}
      </strong>
    );
  } else if (sensor.period === "now" && sensor.status === "onNoData") {
    soilMoisture = gettext("No data");
  }

  //if (sensor.status === 'new' || sensor.period === 'past' || sensor.period === 'future' || sensor.status === 'onNoData'
  var statusDrop = <DropIcon className="icon text-gray is-inline" />;
  if (sensor.soilMoistureStatus === "aboveFieldCapacity") {
    statusDrop = <DropIcon className="icon text-blue is-inline" />;
  } else if (sensor.soilMoistureStatus === "belowRefillPoint") {
    statusDrop = <DropIcon className="icon text-red is-inline" />;
  } else if (sensor.soilMoistureStatus === "belowWarningPoint") {
    statusDrop = <DropIcon className="icon text-yellow is-inline" />;
  } else if (sensor.soilMoistureStatus === "normal") {
    statusDrop = <DropIcon className="icon text-green is-inline" />;
  }

  // Format precipitation values
  var precipitationSumToday = "";
  if (
    sensor.period === "now" &&
    sensor.status !== "onNoData" &&
    sensor.precipitationSumList !== null
  ) {
    precipitationSumToday =
      cropr.l10n_utils.mm_to_l10n(round(sensor.precipitationSumList.today, precision)) +
      " " +
      cropr.l10n.unit_precipitation_display;
  }

  var precipitationSumYesterday = "";
  if (
    sensor.period === "now" &&
    sensor.status !== "onNoData" &&
    sensor.precipitationSumList !== null
  ) {
    precipitationSumYesterday =
      cropr.l10n_utils.mm_to_l10n(round(sensor.precipitationSumList.yesterday, precision)) +
      " " +
      cropr.l10n.unit_precipitation_display;
  }

  // Format soil refill capacity values
  var refillCapacity = "-";
  if (
    sensor.period === "now" &&
    sensor.status !== "onNoData" &&
    (sensor.refillCapacity || sensor.refillCapacity === 0)
  ) {
    refillCapacity =
      cropr.l10n_utils.mm_to_l10n(round(sensor.refillCapacity, precision)) +
      " " +
      cropr.l10n.unit_precipitation_display;
  }

  var refillCapacity24 = "-";
  if (
    sensor.period === "now" &&
    sensor.advice &&
    sensor.status !== "onNoData" &&
    (sensor.refillCapacity || sensor.refillCapacity === 0)
  ) {
    refillCapacity24 =
      cropr.l10n_utils.mm_to_l10n(round(sensor.advice.now24, precision)) +
      " " +
      cropr.l10n.unit_precipitation_display;
  }

  var refillCapacity48 = "-";
  if (
    sensor.period === "now" &&
    sensor.advice &&
    sensor.status !== "onNoData" &&
    (sensor.refillCapacity || sensor.refillCapacity === 0)
  ) {
    refillCapacity48 =
      cropr.l10n_utils.mm_to_l10n(round(sensor.advice.now48, precision)) +
      " " +
      cropr.l10n.unit_precipitation_display;
  }

  let sensorUrl;
  if (sensor.status === "new") {
    sensorUrl = match.path + "/" + sensor.id + "/edit" + location.search;
  } else {
    sensorUrl = match.path + "/" + sensor.id + "/detail" + location.search;
  }
  var now = moment();
  var sensorname = sensor.name;
  if (sensor.endDate && sensor.endDate.diff(now) < 0) {
    sensorname = sensor.startDate.year() + ": " + sensor.name;
  }
  return (
    <tr>
      <td>
        <Link className={"text-black--120"} to={sensorUrl} title={sensor.serialNumber}>
          {sensorname}
          <CircleIcon className={statusColor} />
          {positionError}
          <span className="type">{sensor.type}</span>
        </Link>
      </td>
      <td>{precipitationSumYesterday}</td>
      <td>{precipitationSumToday}</td>
      <td>
        {statusDrop} {soilMoisture}
      </td>
      <td>{refillCapacity}</td>
      <td>{refillCapacity24}</td>
      <td>{refillCapacity48}</td>
    </tr>
  );
};

export default ListItem;
